import {
  CUSTOMER_NUMBER_LBL,
  CUSTOMER_NAME_LBL,
  CITY_LBL,
  STATE_LBL,
  CUSTOMER_POSTAL_LBL,
  ACCOUNT_GROUP_CODE_LBL,
  ACCOUNT_GROUP_CODE,
  COUNTRY_CODE_OPTIONS,
} from "../../../../constants";
import { PERMISSIONS } from "../../../../constants/permissions";
import { checkCustomerName, checkGroup, checkSalesOffice, checkCustomerGroup, checkPhoneNumberWithoutValidation } from "../../../../utils";
import { stateOptionsForCountry, canAddDomain } from "./basicInfo.rules";

export const BASIC_INFO_CUSTOM_VALIDATORS = {
  checkCustomerName,
  checkGroup,
  checkSalesOffice,
  checkCustomerGroup,
  checkPhoneNumberWithoutValidation,
};

export const BASIC_INFO_SECTIONS = [
  {
    key: "generalData",
    title: "General Data",
    column: "left",
    fields: [
      { key: "customerNumber", label: CUSTOMER_NUMBER_LBL, control: "text", disabled: true },
      {
        key: "customerName",
        label: CUSTOMER_NAME_LBL,
        control: "text",
        required: true,
        validation: { custom: "checkCustomerName" },
      },
      { key: "streetAddress", label: "Address", control: "text" },
      { key: "city", label: CITY_LBL, control: "text" },
      { key: "country", label: "Country", control: "select", options: COUNTRY_CODE_OPTIONS },
      { key: "state", label: STATE_LBL, control: "select", options: stateOptionsForCountry, searchable: true, },
      { key: "postalCode", label: CUSTOMER_POSTAL_LBL, control: "text" },
      { key: "phone", label: "Phone", control: "text", validation: { custom: "checkPhoneNumberWithoutValidation" } },
      {
        key: "domain",
        label: "Domain",
        control: "repeatable-text",
        errorFlagKey: "domainErrors",
        addLabel: "+ Add domain",
        canAddRow: canAddDomain,
      },
    ],
  },
  {
    key: "salesArea",
    title: "Sales Area",
    column: "right",
    fields: [
      {
        key: "accountGroup",
        label: ACCOUNT_GROUP_CODE_LBL,
        control: "select",
        options: ACCOUNT_GROUP_CODE,
        required: true,
        disabled: true,
        validation: { custom: "checkGroup" },
      },
      {
        key: "salesOfficeDescription",
        label: "Sales Office",
        control: "select",
        options: (form, extra) => extra?.salesOfficeOptions || [],
        placeholder: "Select",
        required: true,
        searchable: true,
        permission: PERMISSIONS.CUSTOMER_SALES_AREA_EDIT,
        validation: { custom: "checkSalesOffice" },
      },
      {
        key: "customerGroup",
        label: "Customer Group",
        control: "select",
        options: (form, extra) => extra?.customerGroupOptions || [],
        placeholder: "Select",
        required: true,
        searchable: true,
        permission: PERMISSIONS.CUSTOMER_SALES_AREA_EDIT,
        validation: { custom: "checkCustomerGroup" },
      },
      {
        key: "woundCareSalesRepName",
        label: "Wound Care Sales Rep",
        control: "text",
        permission: PERMISSIONS.CUSTOMER_SALES_AREA_EDIT,
      },
      {
        key: "divisionManagerName",
        label: "Division Manager",
        control: "text",
        permission: PERMISSIONS.CUSTOMER_SALES_AREA_EDIT,
      },
    ],
  },
];

export const CREATE_CUSTOMER_FIELDS = [
  {
    key: "customerName",
    label: CUSTOMER_NAME_LBL,
    control: "text",
    required: true,
    validation: { custom: "checkCustomerName" },
  },
  { key: "phone", label: "Phone", control: "text", validation: { custom: "checkPhoneNumberWithoutValidation" } },
  {
    key: "accountGroup",
    label: ACCOUNT_GROUP_CODE_LBL,
    control: "select",
    options: ACCOUNT_GROUP_CODE,
    required: true,
    validation: { custom: "checkGroup" },
  },
  {
    key: "salesOfficeDescription",
    label: "Sales Office",
    control: "select",
    options: (form, extra) => extra?.salesOfficeOptions || [],
    placeholder: "Select",
    required: true,
    validation: { custom: "checkSalesOffice" },
  },
  { key: "country", label: "Country", control: "select", options: COUNTRY_CODE_OPTIONS },
  { key: "streetAddress", label: "Address", control: "text" },
  { key: "postalCode", label: CUSTOMER_POSTAL_LBL, control: "text" },
  { key: "city", label: CITY_LBL, control: "text" },
  { key: "state", label: STATE_LBL, control: "select", options: stateOptionsForCountry },
];

export const CREATE_CUSTOMER_ROWS = [
  ["customerName", "phone"],
  ["accountGroup", "salesOfficeDescription"],
  ["country", "streetAddress"],
  ["postalCode", "city", "state"],
];
